import { useState } from 'react'
import { useAppContext } from 'app/AppContext'
import Filtros from './components/Filtros'

export default function Controle() {
  const [laudos, setLaudos] = useState()
  const [globalLoading, setGlobalLoading] = useState(false)
  const { useSetTitle } = useAppContext()
  
  useSetTitle("Relatórios de Controle")

  return (
    <div style={{ display: "flex", flexDirection: 'column', flex: 1 }}>
      <Filtros laudos={laudos} setLaudos={setLaudos} globalLoading={globalLoading} setGlobalLoading={setGlobalLoading} />
    </div>
  )
}
